export function numberOfItemsInShoppingCart(baseShapes) {
  if (!baseShapes) return;

  let sum = 0;
  for (const baseShape of baseShapes) {
    sum += baseShape.products.map(x => x.quantity).reduce((a, b) => a + b);
  }
  return sum;
}

export function currentTimestampSeconds() {
  return Math.round(+new Date() / 1000);
}
